export default __webpack_public_path__ + "locales/lo-LA/FilesSettings.json?hash=4c03bfd59fcc7d8704bb1c225b848dd8";